module.exports = __webpack_public_path__ + "static/media/Support.e38d1741.png";